import React, { useEffect, useState } from "react";
import ContactForm from "../components/rj-components/ContactForm";
import logoImg from "../assets/logos/mj/MJ-LOGO.png";
import CompanyLogo from "../layouts/CompanyLogo";

function Contact() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      className={`bg-ink-700 ${isMobile ? "pt-[100px] px-4" : "p-[90px]"}`}
    >
      <div className="flex flex-col lg:flex-row items-center justify-center gap-8">
        <div className="w-full lg:w-7/12">
          <ContactForm />
        </div>
        <div className="w-full lg:w-5/12 flex justify-center items-center">
          <CompanyLogo size={256} hiddenOnMobile={true} />
        </div>
      </div>
    </div>
  );
}

export default Contact;
